<q-ss-header-logo [appName]="app" [isSplashPage]="isSplashHeader">
</q-ss-header-logo>
